var _defs, _line, _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCr(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cr{fill:none;stroke-linecap:round;stroke-linejoin:round;stroke-width:1.5px;}"))), _line || (_line = /*#__PURE__*/React.createElement("line", {
    className: "cr",
    x2: 15,
    transform: "translate(0.5 4.5)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cr",
    d: "M5.5,12.5h-4a1,1,0,0,1-1-1V1.5a1,1,0,0,1,1-1h13a1,1,0,0,1,1,1v5"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cr",
    d: "M11,15l-2.5.5L9,13l4.5-4.5,2,2Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCr);
export default __webpack_public_path__ + "static/media/cr.56372c0deacff8f4b112d2f61eb9b59b.svg";
export { ForwardRef as ReactComponent };